import React from 'react'
import { useTranslation } from 'react-i18next'

import LeadFormTable from '../../components/LeadFormTable/LeadFormTable'
import ComponentsList from '../../components/ComponentsList/ComponentsList'

const Cookies = ({ project, block }) => {
    const { t } = useTranslation()
    return (
        <>
            <h1>{t('Cookies')}</h1>
            <ComponentsList>
                <LeadFormTable project={project} block={block} />
            </ComponentsList>
        </>
    )
}

export default Cookies
